export default __webpack_public_path__ + "static/media/Temp2.4332db37.png";